// extracted by mini-css-extract-plugin
export default {"thankYouMessage":"W8XMTU","errorMessage":"eis4Mv","errorIcon":"qyQxgW"};